import React, { useState } from 'react';
import './ProjectTile.css';
import ProjectDialog from './ProjectDialog';

function ProjectTile({ project }) {
    const [isDialogOpen, setIsDialogOpen] = useState(false);

    const handleClick = () => {
        setIsDialogOpen(true);
    };

    const handleCloseDialog = () => {
        setIsDialogOpen(false);
    };

    return (
        <>
            <div className="project-tile" onClick={handleClick}>
                <div className="project-image">
                    <img src={project.images[0]} alt={project.title} />
                </div>
                <div className="project-info">
                    <h3>{project.title}</h3>
                    <p>{project.subtitle}</p>
                </div>
            </div>
            {isDialogOpen && (
                <ProjectDialog
                    project={project}
                    onClose={handleCloseDialog}
                />
            )}
        </>
    );
}

export default ProjectTile;